import StampOrder from '../../../../../../../../types/api/stamp-order'
import FormValues from '../types/form-values'
import dayjs from 'dayjs'

export default function getInitialValues(stampOrder?: StampOrder): FormValues {
    if (stampOrder)
        return {
            // number: stampOrder.number,
            stamp: stampOrder.stamp?.documentId || '',
            quantity: stampOrder.quantity,
            estimatedDate: stampOrder.estimatedDate ? dayjs(stampOrder.estimatedDate) : null,
            comment: stampOrder.comment,
            endDate: stampOrder.endDate ? dayjs(stampOrder.endDate) : null,
            orderStatus: stampOrder.orderStatus,
            initiator: stampOrder.initiator?.documentId,
            price: stampOrder.price,
            approximateCost: stampOrder.approximateCost,
        }

    return {
        quantity: 1,
        orderStatus: 'Создан',
    } as FormValues // TODO: поправить
}
